import React, { useState, useEffect } from "react";
import { XCircle, PlusCircle } from "react-bootstrap-icons";
import Axios from "../config/AxiosConfig";
import AddBookingModal from "./models/AddBookingModal";

const Booking = () => {
  const [bookings, setBookings] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);

  useEffect(() => {
    fetchBookings();
  }, [page, searchQuery]);

  const fetchBookings = async () => {
    setLoading(true);
    try {
      const response = await Axios.get(`super-admin/bookings/all`, {
        params: { search: searchQuery, page, limit: 10 },
      });
      setBookings(response.data.data);
      setTotalPages(response.data.pagination.totalPages);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      setBookings([]);
    }
    setLoading(false);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setSearchQuery("");
  };

  return (
    <div className="booking-container">
      <div className="booking-header">
        <h2>Bookings List</h2>
        <button className="booking-add-btn" onClick={() => setAddModalOpen(true)}>
          <PlusCircle size={18} /> Add Booking
        </button>
      </div>
      <div className="search-container">
        <div className="search-input-wrapper">
          <input
            type="text"
            placeholder="Search by Restaurant or User"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <XCircle
              className="clear-icon"
              size={18}
              onClick={handleClearSearch}
            />
          )}
        </div>
        <button onClick={() => setSearchQuery(searchTerm)}>Search</button>
      </div>
      <table className="booking-table">
        <thead>
          <tr>
            <th>SNo</th>
            <th>Booking No</th>
            <th>Restaurant</th>
            <th>User</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Guests</th>
            <th>Booking Date</th>
            <th>Booking Time</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="7" className="loading-row">Loading bookings...</td>
            </tr>
          ) : bookings.length > 0 ? (
            bookings.map((booking, index) => (
              <tr key={booking._id}>
                <td>{index + 1 + (page - 1) * 10}</td>
                <td>{booking.bookingNo}</td>
                <td>{booking.restaurant.restaurantName}</td>
                <td>{booking.user.username}</td>
                <td>{booking.fullName}</td>
                <td>{booking.phoneNumber}</td>
                <td>{booking.email}</td>
                <td>{booking.numberOfGuests}</td>
                <td>{new Date(booking.bookingDateTime).toLocaleDateString()}</td>
                <td>
                  {new Date(booking.bookingDateTime).toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                    timeZone: "UTC",
                  })}
                </td>
                <td>
                  <span className={`status-${booking.bookingStatus}`}>
                    {booking.bookingStatus.charAt(0).toUpperCase() + booking.bookingStatus.slice(1)}
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7">No bookings found</td>
            </tr>
          )}
        </tbody>
      </table>
      {bookings.length > 0 && (
        <div className="pagination">
          <button disabled={page === 1} onClick={() => setPage(page - 1)}>
            Previous
          </button>
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              className={page === i + 1 ? "active" : ""}
              onClick={() => setPage(i + 1)}
            >
              {i + 1}
            </button>
          ))}
          <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>
            Next
          </button>
        </div>
      )}
      {addModalOpen && (
        <AddBookingModal isOpen={addModalOpen} onClose={() => setAddModalOpen(false)} refreshData={fetchBookings} />
      )}
    </div>
  );
};

export default Booking;
